import eventIcon from '../assets/CategoriesIcons/event.png';
import transportIcon from '../assets/CategoriesIcons/transport.png';
import carpenterIcon from '../assets/CategoriesIcons/carpenter.png';
import farmIcon from '../assets/CategoriesIcons/farm.png';
import carIcon from '../assets/CategoriesIcons/car.png';
import treeIcon from '../assets/CategoriesIcons/tree.png';

export const hostCategories = [
  {
    icon: 'rvSites',
    text: 'RV & Camper Sites',
    searchKey: '?pub_related_host_categories=has_all%3Arv-camper-sites',
  },
  {
    icon: 'adventures',
    text: 'Outdoor Adventures',
    searchKey: '?pub_related_host_categories=has_all%3Aoutdoor-adventures',
  },
  {
    icon: 'storage',
    text: 'Space & Storage',
    searchKey: '?pub_related_host_categories=has_all%3Aspace-storage',
  },
  {
    icon: eventIcon,
    isImage: true,
    text: 'Events & Activities',
    searchKey: '?pub_related_host_categories=has_all%3Aevents-activities',
  },
  {
    icon: 'animals',
    text: 'Animals & Grazing',
    searchKey: '?pub_related_host_categories=has_all%3Aanimals-grazing',
  },
];

export const serviceCategories = [
  {
    icon: treeIcon,
    isImage: true,
    text: 'Land & Tree Services',
    searchKey: '?pub_related_service_categories=has_all%3Aland-tree-services',
  },
  {
    icon: eventIcon,
    isImage: true,
    text: 'Event Services & Rentals',
    searchKey: '?pub_related_service_categories=has_all%3Aevent-services-rentals',
  },
  {
    icon: carIcon,
    isImage: true,
    text: 'Vehicle & Equipment Repair',
    searchKey: '?pub_related_service_categories=has_all%3Avehicle-equipment-repair',
  },
  {
    icon: farmIcon,
    isImage: true,
    text: 'Animal & Farm Care',
    searchKey: '?pub_related_service_categories=has_all%3Aanimals-grazing',
  },
  {
    icon: transportIcon,
    isImage: true,
    text: 'Transport & Cleanup',
    searchKey: '?pub_related_service_categories=has_all%3Atransport-cleanup',
  },
  {
    icon: carpenterIcon,
    isImage: true,
    text: 'Outdoor Carpentry',
    searchKey: '?pub_related_service_categories=has_all%3Aoutdoor-carpentry-structures',
  },
];

